import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { setInputFieldRef } from '../../reducers/ui/actions';

const TextArea = styled.textarea`
  width: 100%;
  outline: 0;
  resize: none;
  border: 0;
  background: transparent;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
  min-height: 24px;
  padding: 0;

  &::placeholder {
    color: #9ca3af;
  }

  &:disabled {
    background: #808080;
    &::placeholder {
      color: #ffffff;
    }
  }
`;

class ExpandingTextArea extends Component {
  constructor(props) {
    super(props);
    this.textAreaRef = React.createRef();
  }

  componentDidMount() {
    this.adjustTextAreaHeight();
    this.props.setInputFieldRef(this.textAreaRef);
  }

  componentDidUpdate(prevProps) {
    this.adjustTextAreaHeight();

    if (!prevProps.autoFocus && this.props.autoFocus) {
      this.textAreaRef.current.focus();
    }
  }

  handleChange = e => {
    this.props.onChange(e);
    this.adjustTextAreaHeight();
  };

  adjustTextAreaHeight = () => {
    const textArea = this.textAreaRef.current;
    textArea.style.height = '0px';
    textArea.style.height = `${textArea.scrollHeight === 0 ? 22 : textArea.scrollHeight}px`;
  };

  render() {
    const { onFocus, value, onKeyDown, placeholder, disabled } = this.props;

    // Use custom placeholder when disabled
    const displayPlaceholder = disabled ? 'please pick one of the options above' : placeholder;

    return (
      <TextArea
        onFocus={onFocus}
        value={value}
        onKeyDown={onKeyDown}
        placeholder={displayPlaceholder}
        ref={this.textAreaRef}
        disabled={disabled}
        onChange={this.handleChange}
        data-test-id="chatInput"
      />
    );
  }
}

export default connect(null, { setInputFieldRef })(ExpandingTextArea);



// WEBPACK FOOTER //
// ./src/components/ChatInput/ExpandingTextArea.js